import { createFileRoute } from "@tanstack/react-router";
import Cookies from "js-cookie";
import { useState } from "react";

const COOKIE_VALUE = "1";

export const APPLE_PAY_BETA_COOKIE = "efb_apple_pay_beta";

export function readApplePayBetaCookieEnabled(): boolean {
  return Cookies.get(APPLE_PAY_BETA_COOKIE) === COOKIE_VALUE;
}

function setApplePayBetaCookie(): void {
  Cookies.set(APPLE_PAY_BETA_COOKIE, COOKIE_VALUE, {
    path: "/",
    sameSite: "lax",
    expires: 400,
    secure: typeof window !== "undefined" && window.location.protocol === "https:",
  });
}

function removeApplePayBetaCookie(): void {
  Cookies.remove(APPLE_PAY_BETA_COOKIE, { path: "/" });
}

function BetaFeaturesPage() {
  const [applePayOn, setApplePayOn] = useState(readApplePayBetaCookieEnabled);

  return (
    <div
      className="flex min-h-[60vh] flex-col items-center justify-center gap-6 px-4 py-12"
      dir="ltr"
    >
      <div className="w-full max-w-sm rounded-lg border border-border bg-card p-6 shadow-sm">
        <h1 className="text-lg font-semibold">Beta features</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Controls the Apple Pay cookie{" "}
          <code className="rounded bg-muted px-1 py-0.5 text-xs">{APPLE_PAY_BETA_COOKIE}</code>
        </p>
        <div className="mt-6 flex items-center justify-between gap-4">
          <span className="text-sm font-medium" id="apple-pay-beta-label">
            Apple Pay
          </span>
          <button
            type="button"
            role="switch"
            aria-checked={applePayOn}
            aria-labelledby="apple-pay-beta-label"
            className={
              "relative h-8 w-14 shrink-0 rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 " +
              (applePayOn ? "bg-primary" : "bg-muted")
            }
            onClick={() => {
              if (applePayOn) {
                removeApplePayBetaCookie();
                setApplePayOn(false);
              } else {
                setApplePayBetaCookie();
                setApplePayOn(true);
              }
            }}
          >
            <span
              className={
                "absolute top-1 block h-6 w-6 rounded-full bg-background shadow transition-transform " +
                (applePayOn ? "translate-x-7" : "translate-x-1")
              }
              aria-hidden
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/$lang/beta-features")({
  component: BetaFeaturesPage,
});
